import React from 'react';
import styles from './Spinner.module.css';

const Spinner = ({
  size = 'md',
  color,
  className = '',
  style,
  mt, mb, ml, mr, mx, my, m,
  ...rest
}) => {
  const sizeClass = styles[size] || '';


  const spinnerStyle = { ...style };
  if (color) {
    spinnerStyle.borderTopColor = color;
  }

  if (typeof size === 'string' && (size.includes('px') || size.includes('em') || size.includes('rem'))) {
    spinnerStyle.width = size;
    spinnerStyle.height = size;
  }

  const getSpacingValue = (v) => typeof v === 'number' ? `calc(var(--cipher-spacing-unit) * ${v})` : v;
  if (mt !== undefined) spinnerStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) spinnerStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) spinnerStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) spinnerStyle.marginRight = getSpacingValue(mr);
  if (mx !== undefined) { spinnerStyle.marginLeft = getSpacingValue(mx); spinnerStyle.marginRight = getSpacingValue(mx); }
  if (my !== undefined) { spinnerStyle.marginTop = getSpacingValue(my); spinnerStyle.marginBottom = getSpacingValue(my); }
  if (m !== undefined) spinnerStyle.margin = getSpacingValue(m);
  
  return (
    <div
      className={`${styles.spinnerBase} ${sizeClass} ${className}`}
      style={spinnerStyle}
      role="status"
      aria-live="polite"
      {...rest}
    >
      <span className={styles.visuallyHidden}>Loading...</span>
    </div>
  );
};

export default Spinner;